// extracted by mini-css-extract-plugin
export default {"chartLegend":"chart-legend-module__chartLegend--SoDOB","icon":"chart-legend-module__icon--qMLDt"};